import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-filial',
  templateUrl: './filial.component.html',
  styleUrls: ['./filial.component.css']
})
export class FilialComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
